import { Toaster } from "react-hot-toast";
import { Box, CssBaseline } from "@mui/material";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./App.css";
import RootView from "./components/RootView";
import PublicSessionView from "./components/public/PublicSessionView";
import PublicProfileView from "./components/public/PublicProfileView";
import PublicGroupView from "./components/public/PublicGroupView";
import PublicTeamView from "./components/public/PublicTeamView";
import PublicOrgView from "./components/public/PublicOrgView";
import PublicMixtapeView from "./components/public/PublicMixtapeView";
import PublicReferralView from "./components/public/PublicReferralView";

function App() {
  return (
    <div className="App">
      <Box>
        <CssBaseline />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 5000,
            style: { background: "black", color: "#EEEDEB" },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootView />} />
            <Route path="/profile/:id" element={<PublicProfileView />} />
            <Route path="/session/:id" element={<PublicSessionView />} />
            <Route path="/hoopers/group/:id" element={<PublicGroupView />} />
            <Route path="/hoopers/team/:id" element={<PublicTeamView />} />
            <Route path="/hoopers/org/:id" element={<PublicOrgView />} />
            <Route path="/mixtape/:id" element={<PublicMixtapeView />} />
            <Route path="/i/:referralCode" element={<PublicReferralView />} />
          </Routes>
        </BrowserRouter>
      </Box>
    </div>
  );
}

export default App;
